import { Routes, Route } from "react-router-dom";

import Users from "../screens/users/Users";
import NewUser from "../screens/users/NewUser";
import ProtectedLayout from "../layouts/ProtectedLayout";

import NotFound from "../screens/notfound/NotFound";
import AuthScreen from "../screens/auth/AuthScreen";
import Companies from "../screens/companies/Companies";
import Expenses from "../screens/expenses/Expenses";
import Profile from "../screens/profile/Profile";
import Company from "../screens/companies/Company";
import Category from "../screens/categories/Category";
import ExportDutyLetter from "../screens/export_duty_letters/ExportDutyLetter";
import Tariffs from "../screens/tariff/Tariffs";
import AddNew from "../components/sections/AddNew";
import Settings from "../screens/settings/Settings";
import Invoices from "../screens/invoices/Invoices";
import NewInvoice from "../screens/invoices/NewInvoice";
import Archives from "../screens/archive/Archives";
import NewArchive from "../screens/archive/NewArchive";
import ArchiveList from "../screens/archive/ArchiveList";
import Budgets from "../screens/budgets/Budgets";
import NewTariff from "../screens/tariff/NewTariff";
import NewDutyLetter from "../screens/export_duty_letters/NewDutyLetter";
import Incomes from "../screens/incomes/Incomes";
import CardMembership from "../screens/card_membership/CardMembership";
import NewCompany from "../screens/companies/NewCompany";
import Employees from "../screens/users/Employees";
import Dashboard from "../screens/dashboard/Dashboard";
import Rentals from "../screens/rentals/Rentals";
import Exports from "../screens/exports/Exports";
import UserView from "../screens/users/UserView";
import Backups from "../screens/backups/Backups";
import Logs from "../screens/logs/Logs";
import Zones from "../screens/zones/Zones";
import EmployeeView from "../screens/users/EmployeeView";
import NotAllowed from "../components/partials/NotAllowed";
import ResetPasswordByEmail from "../screens/auth/ResetPasswordByEmail";
import UserRole from "../screens/users/roles/UserRole";
import Reports from "../screens/reports/Reports";
import Cleanliness from "../screens/cleanliness/Cleanliness";

const routes = (

    <Routes >
        <Route path="/db/reset-password" element={<ResetPasswordByEmail />} />
        <Route path="/db/login" element={<AuthScreen />} />

       {/*  MainPage */}
        <Route path="/" /> 

        <Route path="/db" element={<ProtectedLayout />} >
            <Route index={true} element={<Dashboard />}></Route>
            <Route exact path="/db/profile" element={<Profile />}></Route>
            <Route exact path="/db/dashboard" element={<Dashboard />}></Route>
            <Route exact path="/db/tariffs/:id">
                <Route index={true} element={<Tariffs />}></Route>
                <Route exact path="new_tariff/:id" element={<NewTariff />}></Route>
            </Route>
            <Route exact path="/db/invoices/:id">
                <Route index={true} element={<Invoices />}></Route>
                <Route exact path="new_invoice/:id" element={<NewInvoice />}></Route>
            </Route>
            <Route exact path="/db/export_duty_letters/:id">
                <Route index={true} element={<ExportDutyLetter />}></Route>
                <Route exact path="new_letter/:id" element={<NewDutyLetter />}></Route>
            </Route>


            <Route exact path="/db/users">
                <Route index={true} element={<Users />}></Route>
                <Route path="/db/users/new_user/:id" element={<NewUser />}></Route>
            </Route>

            <Route exact path="/db/companies">
                <Route index={true} element={<Companies />}></Route>
                <Route exact path="/db/companies/company" element={<Company />}></Route>
                <Route exact path="/db/companies/new_company/:id" element={<NewCompany />}></Route>
            </Route>

            <Route exact path="/db/invoices/:id">
                <Route index={true} element={<Invoices />}></Route>
                <Route exact path="new_invoice/:id" element={<NewInvoice />}></Route>
            </Route>
          

            <Route exact path="archives">
                <Route index={true} element={<Archives />}></Route>
                <Route exact path="/db/archives/new_archive/:id" element={<NewArchive />}></Route>
                <Route exact path="/db/archives/list_archive/:id" element={<ArchiveList />}></Route>
            </Route>


            <Route exact path="/db/expenses/:id">
                <Route index={true} element={<Expenses />}></Route>
            </Route>

            <Route path="/db/obj/add_new/:id" element={<AddNew />}></Route>


            <Route exact path="/db/categories">
                <Route index={true} element={<Category />}></Route>
            </Route>
            <Route exact path="/db/card_membership">
                <Route index={true} element={<CardMembership />}></Route>
            </Route>

            <Route exact path="/db/zones">
                <Route index={true} element={<Zones />}></Route>
            </Route>

            <Route exact path="/db/users" >
                <Route path="/db/users/usrs" element={<Users />}></Route>
                <Route exact path="/db/users/employees/:id" element={<Employees />}></Route>
                <Route path="/db/users/new_user/:id" element={<NewUser />}></Route>
                <Route path="/db/users/view_user/:id" element={<UserView />}></Route>
                <Route path="/db/users/view_employee/:id" element={<EmployeeView />}></Route>
                <Route exact path="/db/users/user_roles" element={<UserRole />}></Route>

            </Route>

            <Route exact path="/db/exports">
                <Route index={true} element={<Exports />}></Route>
            </Route>

            <Route exact path="/db/cleanliness">
                <Route index={true} element={ <Cleanliness />}></Route>
            </Route>
            <Route exact path="/db/rentals">
                <Route index={true} element={<Rentals />}></Route>
            </Route>
            <Route exact path="/db/budgets">
                <Route index={true} element={<Budgets />}></Route>
            </Route>

            <Route exact path="/db/incomes">
                <Route index={true} element={<Incomes />}></Route>
            </Route>
            <Route exact path="/db/reports">
                <Route index={true} element={<Reports />}></Route>
            </Route>
            <Route exact path="/db/logs">
                <Route index={true} element={<Logs />}></Route>
            </Route>
            <Route exact path="/db/backups">
                <Route index={true} element={<Backups />}></Route>
            </Route>
            <Route exact path="/db/settings">
                <Route index={true} element={<Settings />}></Route>
            </Route>

            <Route path="/db/notAllowed" element={<NotAllowed />} />
            <Route path="*" element={<NotFound />} />

        </Route>
        <Route path="*" element={<NotFound />} />
    </Routes>

)
export default routes;